import {invariant} from '~/library/toolbox';
import {selectWithdrawFiatOperations, uniqueById} from "../SelectorTools";
import {WithdrawPageProps} from "../../ui/Withdraw/WithdrawPage";
import {FinancialData} from '~/redux/finances';
import {TopupParams} from '../../ui/Topup/TopupPage';

export function selectWithdrawData(params: TopupParams) {
    const {accountId, methodType, methodId} = params;
    return function (finData: FinancialData): WithdrawPageProps | null {
        const currentAccount = finData.accounts.find(acc => acc.id === accountId);
        if (!currentAccount) return null;

        const provider = finData.providers.find(p => p.id === currentAccount.providerId);
        invariant(!!provider, `Provider with id ${currentAccount.providerId} not found`);

        const providerName = provider.name;

        const withdrawOperations = selectWithdrawFiatOperations(finData);
        const operationsForAccount = withdrawOperations.filter(op => op.account.id === currentAccount.id);

        const accounts = uniqueById(
            withdrawOperations.filter(op => op.account.providerId === provider.id).map(op => op.account)
        );

        const methods = uniqueById(
            operationsForAccount.filter(op => op.account.id === currentAccount.id).map(op => op.target)
        );
        const method = methods.find(m => m.type === methodType && m.id === methodId);

        return {
            providerName,
            accounts,
            methods,
            account: currentAccount,
            method,
            operations: withdrawOperations,
            ...params,
        };
    };
}
